module.exports = function ($q) {
    /**
     * Takes a function that returns a promise and creates a new function that,
     * when called many times will reject previously returned promises when they
     * resolve.
     * @param {Function} fn - Function that returns a promise
     * @param {Object} [context] - The context to bind the function to.
     * @returns {Promise}
     */
    return function serializeAsync(fn, context) {
        let callCount = 0;

        return function () {
            callCount++;
            const version = callCount;
            const promise = fn.apply(context, arguments);

            return promise.then(function () {
                if (version < callCount) {
                    return $q.reject('Async action superseded.');
                }

                return promise;
            });
        };
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/serializeasync/serializeasync.js
 **/